export default "__VITE_ASSET__DDWNaBwi__"